
import {Component, Vue} from "vue-property-decorator";
import TakipList from "@/components/lists/TakipList.vue";

@Component({
  components: {TakipList}
})
export default class TakipListView extends Vue {
}
